import { Vendor } from "../../../../types/vendors.types";
import NoVendorsPanel from "../NoVendorsPanel";

import ReferVendor from "./ReferVendor";
import VendorItem from "./VendorItem";

const VISIBLE_VENDOR_STATUSES = ["ACTIVATED", "PENDING"];

type MyVendorsProps = {
  vendors?: Vendor[];
  activeFilter?: string;
  hasFetched?: boolean;
  hasListings?: boolean;
};

const MyVendors = ({
  vendors = [],
  activeFilter,
  hasFetched = true,
  hasListings = true,
}: MyVendorsProps) => {
  const visibleVendors = vendors.filter((vendor) =>
    VISIBLE_VENDOR_STATUSES.includes(vendor?.status),
  );

  if (0 === visibleVendors.length) {
    return hasFetched && "services" === activeFilter ? (
      <NoVendorsPanel />
    ) : null;
  }

  const showReferVendor =
    "services" === activeFilter || ("all" === activeFilter && !hasListings);

  return (
    <div className="tw-mt-40">
      {visibleVendors.map((vendor) => {
        return <VendorItem key={vendor._id} vendor={vendor} />;
      })}
      {showReferVendor && <ReferVendor />}
    </div>
  );
};

export default MyVendors;
